import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { Colors, Shapes } from 'src/components/theme'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { FlexColumn } from 'src/components/flex-containers'
import { SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS } from 'src/constants/subscriptions'
import { SubscriptionModalHeader } from 'src/views/subscriptions/header'
import { SubscriptionFeatureList } from 'src/views/subscriptions/feature-list'
import { SubscriptionModalFooter } from 'src/views/subscriptions/footer'
import { SUBSCRIPTION_UPDATE_STEPS } from 'src/atoms/payments'
import { useCloseAndResetSubscriptionModal } from 'src/views/subscriptions/hooks'

import * as paymentsAtoms from 'src/atoms/payments'

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${Shapes.spacing[2]}px;
  width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  max-width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  margin: 0 auto;
`

export const PlanReminder = () => {
  const selectedPaymentPlan = useRecoilValue(paymentsAtoms.selectedPaymentPlan)
  const setSubscriptionUpdateStep = useSetRecoilState(paymentsAtoms.subscriptionUpdateStep)
  const closeAndResetSubscriptionModal = useCloseAndResetSubscriptionModal()

  const features = [
    'Branding Features',
    'Zoning Reports',
    'Location Visit Reports',
    'Ownership',
    'Ranking Reports',
    'Misc Stuff',
    'Branding Features',
    'More Stuff',
    'Misc Stuff',
  ]

  const onBack = () => closeAndResetSubscriptionModal()
  const onNext = () => setSubscriptionUpdateStep(SUBSCRIPTION_UPDATE_STEPS.PAYMENT)

  return (
    <Wrapper>
      <FlexColumn gap={Shapes.spacing[4]}>
        <SubscriptionModalHeader>
          <Typography variant="header2" color={Colors.textBlack}>
            {selectedPaymentPlan?.name} Plan
          </Typography>
        </SubscriptionModalHeader>
        <Typography variant="title1">
          ⚠️ You will lose access to the following items after your current billing period
        </Typography>
        <SubscriptionFeatureList features={features} type="lost" />
      </FlexColumn>
      <SubscriptionModalFooter>
        <ButtonWithIcon onClick={onBack}>Back</ButtonWithIcon>
        <ButtonWithIcon onClick={onNext} inverted>
          Next
        </ButtonWithIcon>
      </SubscriptionModalFooter>
    </Wrapper>
  )
}
